import React from 'react'
import { Text } from 'rebass'
export default props => (
  <Text fontFamily={'regular'} color={'white'} {...props} />
)
